/* noted. — Skipstone allocation lines, reading order.

   Awtomic prints the lines of an allocation in whatever order its own data
   holds, which put the olive oil between the two wines. Justin, 2026-08-21:
   Oliver's, Malbec, olive oil, in that order.

   The order itself is config and lives in assets/skipstone-tiers.js as
   window.SKIPSTONE_BUNDLE_ORDER. Nothing in this file names a wine.

   ------------------------------------------------------------------
   WHY MOVING ROWS IS SAFE HERE WHEN INSERTING ONE WAS NOT.

   Earlier tonight a zero-width span added as a sibling inside
   .awt-bundle-update-footer-button-info put the portal on a spinner. React
   holds an index for every child it manages, and a foreign node shifts them.

   Moving is a different operation. React's reconciler holds a direct
   reference to each row it rendered, not a position, and insertBefore(node,
   ref) lands correctly whatever order the DOM is currently in.

   Verified on the live membership page: rows reordered, modal stayed open, no
   spinner, no console error, and the new order was still holding minutes later
   through several re-renders. React does not fight it.

   THE RULE THIS SITS UNDER: never add or remove children in Awtomic's tree.
   Moving existing ones, and writing inside a leaf, is the whole permitted set.

   ------------------------------------------------------------------
   WHY setTimeout AND NOT requestAnimationFrame.

   This shipped once with an rAF debounce and did nothing at all. rAF does not
   fire in a background tab, so the queued flag latched on and every later
   mutation was swallowed. The page looked untouched.

   A member who opens their allocation in a background tab, which is exactly
   what happens when the billing email is opened into a new tab, would have got
   the same nothing. A timer runs either way.
   ------------------------------------------------------------------

   EACH RUN OF LINES IS SORTED ON ITS OWN. The membership list page shows every
   membership at once, so one tbody can hold several allocations, each a parent
   row followed by its own lines. Sorting the tbody as a whole would shuffle
   one member's wine into another's. Only the contiguous run of child rows
   between two parent rows is ever touched.

   THE SORT IS STABLE. Anything the config does not name keeps the order
   Awtomic gave it. */
(function () {
  "use strict";

  if (window.location.pathname.indexOf("/tools/bundle-subscriptions") === -1) return;

  var CHILD = "bundle-table__body-row--bab-child";

  /* The literal is a fallback for one case only, skipstone-tiers.js failing to
     load. It is the order Justin asked for and nothing more. */
  function config() {
    var c = window.SKIPSTONE_BUNDLE_ORDER || {};
    return {
      first: c.first || ["oliver's blend", "malbec"],
      last: c.last || ["olive oil"]
    };
  }

  /* Lower sorts earlier. The 1000 gap in the middle is where everything the
     config does not name lands, keeping its original order. */
  function rank(text, cfg) {
    var t = (text || "").toLowerCase();
    var i;
    for (i = 0; i < cfg.first.length; i++) {
      if (t.indexOf(cfg.first[i]) !== -1) return i;
    }
    for (i = 0; i < cfg.last.length; i++) {
      if (t.indexOf(cfg.last[i]) !== -1) return 2000 + i;
    }
    return 1000;
  }

  function nameOf(row) {
    var cell = row.firstElementChild || row;
    return cell.textContent;
  }

  function sortRun(tbody, run, after, cfg) {
    var wanted = run
      .map(function (row, i) {
        return { row: row, i: i, k: rank(nameOf(row), cfg) };
      })
      .sort(function (a, b) {
        return (a.k - b.k) || (a.i - b.i);
      })
      .map(function (o) { return o.row; });

    var same = wanted.every(function (row, i) { return row === run[i]; });
    if (same) return;

    wanted.forEach(function (row) { tbody.insertBefore(row, after); });
  }

  function pass() {
    var cfg = config();
    Array.prototype.forEach.call(
      document.querySelectorAll("tbody.bundle-table__body"),
      function (tbody) {
        var kids = Array.prototype.slice.call(tbody.children);
        var i = 0;
        while (i < kids.length) {
          if (!kids[i].classList.contains(CHILD)) { i++; continue; }
          var run = [];
          while (i < kids.length && kids[i].classList.contains(CHILD)) {
            run.push(kids[i]);
            i++;
          }
          sortRun(tbody, run, kids[i] || null, cfg);
        }
      }
    );
  }

  function safePass() {
    try { pass(); } catch (e) { console.warn("[skipstone-bundle-order]", e); }
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; safePass(); }, 60);
  }

  function start() {
    try {
      safePass();
      new MutationObserver(schedule).observe(document.body, {
        childList: true, subtree: true
      });
      document.body.addEventListener("click", function () {
        setTimeout(safePass, 200);
      }, true);
    } catch (e) {
      console.warn("[skipstone-bundle-order] disabled", e);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
